import { BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes, { Account } from "model";
import TASPositivePayImportChecksProcessingPage, { getDefaultUI } from "components/pages/TASPositivePayImportChecksProcessingPage";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";

/**
 * @name CapturePositivePayImportChecksImportProcessing
 * @returns {React.Component}
 * @description A capture in the "Positive Pay - Import Checks" capture group.
 */
export default function CapturePositivePayImportChecksImportProcessing(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const hasBusinessAccounts = Account.hasBusinessAccounts(branding);

    if(!hasBusinessAccounts) {
        const message = Account.businessOnlyBrandingErrorMessage;
        return <CaptureNotShownView message={ message }/>;
    }

    const ui = BCMSStateManagerCRUD.init( getDefaultUI())
    .update([ "timeout", "useTimeout" ], false)
    .submit();

    return <TASPositivePayImportChecksProcessingPage ui={ ui }  />;
}